import { t as B } from "../i18n.mjs";
function h(t, r = 2, o) {
  if (t < 0) return (o == null ? void 0 : o.whenNegative) ?? B("file_manager.processing_size");
  if (t === 0) return "0 Bytes";
  const e = 1024, i = r < 0 ? 0 : r, s = ["Bytes", "KB", "MB", "GB"], n = Math.floor(Math.log(t) / Math.log(e));
  return parseFloat((t / Math.pow(e, n)).toFixed(i)) + " " + s[n];
}
export {
  h as formatBytes
};
